import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEudrStore,
	TEudrRegParseRequest,
	TEudrRegParseResponsePayload,
	TEudrRegisterRequest,
	TEudrPlansResponsePayload,
	TEudrServiceStatusesResponsePayload,
	TEudrItemsRequest,
	TEudrItemsResponsePayload,
	TGenerateEudrInvoiceRequest,
	TDownloadEudrLastInvoiceRequest,
	TEudrActivateRequest,
} from './types';

export const initialState: TEudrStore = {
	regParser: null,
	regParserLoading: false,
	regParserError: '',
	registerLoading: false,
	registerError: '',
	plans: null,
	serviceStatuses: null,
	eudrItems: null,
	eudrItemsLoading: false,
	generateInvoiceEudrLoading: false,
	downloadEudrLastInvoiceLoading: false,
	activateEudrLoading: false,
	activateEudrError: '',
};

const eudr = createSlice({
	name: '@@eudr',
	initialState,
	reducers: {
		regParseEudrRequest: (state: TEudrStore, _action: PayloadAction<TEudrRegParseRequest>) => {
			const nextState = state;
			nextState.regParserLoading = true;
			nextState.regParser = null;
			nextState.regParserError = '';
		},
		regParseEudrSuccess: (
			state: TEudrStore,
			action: PayloadAction<TEudrRegParseResponsePayload>,
		) => {
			const { payload } = action;
			const nextState = state;
			nextState.regParser = payload;
			nextState.regParserLoading = false;
			nextState.regParserError = '';
		},
		regParseEudrFailure: (state: TEudrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const nextState = state;
			nextState.regParserLoading = false;
			nextState.regParserError = error;
		},

		registerEudrRequest: (state: TEudrStore, _action: PayloadAction<TEudrRegisterRequest>) => {
			const nextState = state;
			nextState.registerLoading = true;
			nextState.registerError = '';
		},
		registerEudrSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.registerLoading = false;
			nextState.registerError = '';
		},
		registerEudrFailure: (state: TEudrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const nextState = state;
			nextState.registerLoading = false;
			nextState.registerError = error;
		},

		getEudrPlansRequest: (state: TEudrStore) => {
			const nextState = state;
			nextState.plans = null;
		},
		getEudrPlansSuccess: (state: TEudrStore, action: PayloadAction<TEudrPlansResponsePayload>) => {
			const { payload } = action;
			const nextState = state;
			nextState.plans = payload;
		},
		getEudrServiceStatusesRequest: (state: TEudrStore) => {
			const nextState = state;
			nextState.serviceStatuses = null;
		},
		getEudrServiceStatusesSuccess: (
			state: TEudrStore,
			action: PayloadAction<TEudrServiceStatusesResponsePayload>,
		) => {
			const { payload } = action;
			const nextState = state;
			nextState.serviceStatuses = payload;
		},

		getEudrItemsRequest: (state: TEudrStore, _action: PayloadAction<TEudrItemsRequest>) => {
			const nextState = state;
			nextState.eudrItemsLoading = true;
		},
		getEudrItemsSuccess: (state: TEudrStore, action: PayloadAction<TEudrItemsResponsePayload>) => {
			const { payload } = action;
			const nextState = state;
			nextState.eudrItems = payload;
			nextState.eudrItemsLoading = false;
		},

		generateInvoiceEudrRequest: (
			state: TEudrStore,
			_action: PayloadAction<TGenerateEudrInvoiceRequest>,
		) => {
			const nextState = state;
			nextState.generateInvoiceEudrLoading = true;
		},
		generateInvoiceEudrSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.generateInvoiceEudrLoading = false;
		},

		downloadEudrLastInvoiceRequest: (
			state: TEudrStore,
			_action: PayloadAction<TDownloadEudrLastInvoiceRequest>,
		) => {
			const nextState = state;
			nextState.downloadEudrLastInvoiceLoading = true;
		},
		downloadEudrLastInvoiceSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.downloadEudrLastInvoiceLoading = false;
		},

		activateEudrRequest: (state: TEudrStore, _action: PayloadAction<TEudrActivateRequest>) => {
			const nextState = state;
			nextState.activateEudrLoading = true;
			nextState.activateEudrError = '';
		},
		activateEudrSuccess: (state: TEudrStore) => {
			const nextState = state;
			nextState.activateEudrLoading = false;
			nextState.activateEudrError = '';
		},
		activateEudrFailure: (state: TEudrStore, action: PayloadAction<{ error: string }>) => {
			const { error } = action.payload;
			const nextState = state;
			nextState.activateEudrLoading = false;
			nextState.activateEudrError = error;
		},

		eudrInitState: () => initialState,
	},
});

export default eudr.reducer;
export const {
	eudrInitState,
	regParseEudrRequest,
	regParseEudrSuccess,
	regParseEudrFailure,
	registerEudrRequest,
	registerEudrSuccess,
	registerEudrFailure,
	getEudrPlansRequest,
	getEudrPlansSuccess,
	getEudrServiceStatusesRequest,
	getEudrServiceStatusesSuccess,
	getEudrItemsRequest,
	getEudrItemsSuccess,
	generateInvoiceEudrRequest,
	generateInvoiceEudrSuccess,
	downloadEudrLastInvoiceRequest,
	downloadEudrLastInvoiceSuccess,
	activateEudrRequest,
	activateEudrSuccess,
	activateEudrFailure,
} = eudr.actions;
